"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
exports.default = (function (state) { return (tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, state.location.query || {}), state.routeParams || {}), state.params || {})); });
//# sourceMappingURL=route_params.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/helpers/route_params.js
// module id = QCDE
// module chunks = 20 21